import React from 'react';
import Button from '../../../components/Buttons/Button';
import { IAddToOrder } from '../../../models/try2Combo';

const AddToOrder: React.FC<IAddToOrder> = ({ order, addToOrder, loading, showCustomization}) => {
  const isDisableButton = () => {
    let disable = false;
    for (let i = 0; i < order.modifiers.length - 1; i++) {
      if(!order.modifiers[i].is_selected){
        disable = true; 
      }
    }
    return disable
  }
  return (
    <Button
      type="button"
      className='xl'
      disabled={isDisableButton()}
      onClick={addToOrder}
      loading={loading}
    >
      {!showCustomization ? "ADD TO ORDER" : "UPDATE ORDER"}
    </Button>
  );
};

export default AddToOrder;
